import { Organization } from '@src/Infrastructure/Types/OrganizationType'

export const SITEMAP_TRANSLATION = 'Sitemap'
export const FREIGHT_RESOURCES_TRANSLATION = 'Freight Resources'
export const FREIGHT_GUIDE_TRANSLATION = 'Freight Guide'
export const HELP_CENTER_TRANSLATION = 'Help Center'
export const HELP_CENTER_CATEGORIES_TRANSLATION = 'Help Center Categories'
export const BLOG_TRANSLATION = 'Blog'
export const BLOG_CATEGORIES_TRANSLATION = 'Blog Categories'
export const ALL_PAGES_TRANSLATION = 'All Pages'
export const HOME_TRANSLATION = 'Home'
export const PAGE_NOT_FOUND_TRANSLATION = '404: PAGE NOT FOUND'
export const PAGE_NOT_FOUND_CONTENT_TRANSLATION_ICONTAINERS =
    'We apologize, but we cannot find the page you\'re looking for. Please start your search from <a href="/">iContainers homepage</a>'
export const PAGE_NOT_FOUND_CONTENT_TRANSLATION_BOXIT4ME =
    'We apologize, but we cannot find the page you\'re looking for. Please start your search from <a href="/">Boxit4me homepage</a>'
export const PAGE_NOT_FOUND_CONTENT_TRANSLATION_VELOCITY =
    'We apologize, but we cannot find the page you\'re looking for. Please start your search from <a href="/">Velocity homepage</a>'
export const PAGE_NOT_FOUND_CONTENT_TRANSLATION_SHIPAX =
    'We apologize, but we cannot find the page you\'re looking for. Please start your search from <a href="/">ShipaX homepage</a>'
export const PAGE_DELETED_TRANSLATION = '410 : THIS WEBPAGE WAS DELETED'

export const DEFAULT_DO_NOT_FOUND_TRANSALTION: Record<Organization, string> = {
    icontainers: PAGE_NOT_FOUND_CONTENT_TRANSLATION_ICONTAINERS,
    boxit4me: PAGE_NOT_FOUND_CONTENT_TRANSLATION_BOXIT4ME,
    velocity: PAGE_NOT_FOUND_CONTENT_TRANSLATION_VELOCITY,
    shipax: PAGE_NOT_FOUND_CONTENT_TRANSLATION_SHIPAX,
}
